import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const StartProgressReport = createAsyncThunk(
  "StartProgressReport/StartProgressReport",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/WorkFlow/StartProgressReport",
        param
      );

      // Extract data from the response object
      const data = response.data; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const ChangeStatusReportStage = createAsyncThunk(
  "StartProgressReport/ChangeStatusReportStage",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/ReportStage/ChangeStatusReportStage",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetSpecificRowReportStage = createAsyncThunk(
  "StartProgressReport/GetSpecificRowReportStage",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/ReportStage/GetSpecificRowReportStage",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AddAttachment = createAsyncThunk(
  "StartProgressReport/AddAttachment",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/ReportStage/AddAttachment",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const ValidationPageReport = createAsyncThunk(
  "StartProgressReport/ValidationPageReport",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/ReportStage/ValidationPageReport",
        param
      );

      // Extract data from the response object
      const data = response.data; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const StartProgressReportReducer = createSlice({
  name: "StartProgressReportReducer",
  initialState: {
    StartProgressReportReducer: {},
    loadingStartProgressReportReducer: false,
    errorStartProgressReportReducer: null,
    ////////////////
    ChangeStatusReportStage: {},
    loadingChangeStatusReportStage: false,
    errorChangeStatusReportStage: null,
    ////////////////
    ReportStage: {},
    loadingReportStage: false,
    errorReportStage: null,
    ////////////////
    AddAttachment: {},
    loadingAddAttachment: false,
    errorAddAttachment: null,
    ////////////////
    ValidationPageReport: {},
    loadingValidationPageReport: false,
    errorValidationPageReport: null,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(StartProgressReport.pending, (state, action) => {
        state.loadingStartProgressReportReducer = true;
        state.StartProgressReportReducer = action.payload;
        state.errorStartProgressReportReducer = null;
      })
      .addCase(StartProgressReport.fulfilled, (state, action) => {
        state.loadingStartProgressReportReducer = false;
        state.ReportStatus = action.payload; // Assuming payload has the desired data
      })
      .addCase(StartProgressReport.rejected, (state, action) => {
        state.loadingStartProgressReportReducer = false;
        state.errorStartProgressReportReducer = action.payload;
      });

    builder
      .addCase(ChangeStatusReportStage.pending, (state, action) => {
        state.loadingChangeStatusReportStage = true;
        state.ChangeStatusReportStage = action.payload;
        state.errorChangeStatusReportStage = null;
      })
      .addCase(ChangeStatusReportStage.fulfilled, (state, action) => {
        state.loadingChangeStatusReportStage = false;
        state.ChangeStatusReportStage = action.payload; // Assuming payload has the desired data
      })
      .addCase(ChangeStatusReportStage.rejected, (state, action) => {
        state.loadingChangeStatusReportStage = false;
        state.errorChangeStatusReportStage = action.payload;
      });

    builder
      .addCase(GetSpecificRowReportStage.pending, (state, action) => {
        state.loadingReportStage = true;
        state.ReportStage = action.payload;
        state.errorReportStage = null;
      })
      .addCase(GetSpecificRowReportStage.fulfilled, (state, action) => {
        state.loadingReportStage = false;
        state.ReportStage = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetSpecificRowReportStage.rejected, (state, action) => {
        state.loadingReportStage = false;
        state.errorReportStage = action.payload;
      });

    builder
      .addCase(AddAttachment.pending, (state, action) => {
        state.loadingAddAttachment = true;
        state.AddAttachment = action.payload;
        state.errorReportStage = null;
      })
      .addCase(AddAttachment.fulfilled, (state, action) => {
        state.loadingAddAttachment = false;
        state.AddAttachment = action.payload; // Assuming payload has the desired data
      })
      .addCase(AddAttachment.rejected, (state, action) => {
        state.loadingAddAttachment = false;
        state.errorAddAttachment = action.payload;
      });

      builder
      .addCase(ValidationPageReport.pending, (state, action) => {
        state.loadingValidationPageReport = true;
        state.ValidationPageReport = action.payload;
        state.errorValidationPageReport = null;
      })
      .addCase(ValidationPageReport.fulfilled, (state, action) => {
        state.loadingValidationPageReport = false;
        state.ValidationPageReport = action.payload; // Assuming payload has the desired data
      })
      .addCase(ValidationPageReport.rejected, (state, action) => {
        state.loadingValidationPageReport = false;
        state.errorValidationPageReport = action.payload;
      });
  },
});

export default StartProgressReportReducer.reducer;
